import { useNavigate } from "react-router-dom";
import { PurchaseShell } from "../features/purchase/PurchaseShell";
import { PurchaseBuilder } from "../features/purchase/PurchaseBuilder";

// صفحة إنشاء مستند شراء جديد.
export default function PurchaseNewDocPage({ tab, docType }) {
  const navigate = useNavigate();
  const list = `/purchases/${tab}`;

  return (
    <PurchaseShell titleKey={tab}>
      <PurchaseBuilder docType={docType} onCreated={() => navigate(list)}
                       onCancel={() => navigate(list)} />
    </PurchaseShell>
  );
}
